import { Component, OnInit, OnDestroy } from '@angular/core';
import {AuthGuard} from "../../service/auth-guard.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit, OnDestroy {

  constructor(private router: Router) {
    document.body.classList.add('welcome');
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    document.body.classList.remove('welcome');
  }

  redirect() {
    const isLoggedIn = localStorage.getItem('isLoggedIn') || AuthGuard.readCookie('isLoggedIn');
    if (isLoggedIn) {
      this.router.navigateByUrl('/home');
    }else {
      this.router.navigateByUrl('/auth');
    }
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/info/info.component.ts